import React, { useCallback, useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { billingError, downloadBatch, listBatches } from "./billingApi";
import { Button, DummyPill, Pill, money } from "./ui";

/* Billing > Files: every 837 batch (and Athena submission) with its download. */

const FilesTab = ({ toast, refreshKey }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await listBatches();
      setRows(r.batches || []);
    } catch (e) {
      toast(billingError(e, "Could not load files"), "error");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);

  const download = async (b) => {
    try {
      await downloadBatch(b.id, b.file_name);
    } catch (e) {
      toast(billingError(e, "Could not download the file"), "error");
    }
  };

  return (
    <div className="bg-white rounded-xl border border-[#E5E7EB] overflow-hidden">
      {loading ? (
        <div className="flex justify-center py-12"><CircularProgress size={26} /></div>
      ) : rows.length === 0 ? (
        <div className="text-center text-[13px] text-[#6B7280] py-12">No files yet. Create one in the Generate tab.</div>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[11px] text-[#6B7280] bg-[#F9FAFB]">
              <th className="px-3 py-2">Batch</th><th className="px-3 py-2">Created</th><th className="px-3 py-2">By</th>
              <th className="px-3 py-2">Kind</th><th className="px-3 py-2">Claims</th><th className="px-3 py-2 text-right">Total</th>
              <th className="px-3 py-2">Mode</th><th className="px-3 py-2" />
            </tr>
          </thead>
          <tbody>
            {rows.map((b) => (
              <tr key={b.id} className="border-t border-[#F3F4F6]">
                <td className="px-3 py-2 font-mono text-[12px] text-[#18181B]">{b.file_name || `#${b.id}`}</td>
                <td className="px-3 py-2 text-[#374151]">{b.created_at}</td>
                <td className="px-3 py-2 text-[#374151]">{b.created_by}</td>
                <td className="px-3 py-2">{b.kind === "athena" ? <Pill className="bg-green-100 text-green-700">Athena</Pill>
                                                              : <Pill className="bg-indigo-50 text-indigo-700">837 file</Pill>}</td>
                <td className="px-3 py-2 text-[#374151]">{b.claim_count}</td>
                <td className="px-3 py-2 text-right text-[#374151]">{money(b.total_charge)}</td>
                <td className="px-3 py-2 flex items-center gap-1">
                  {b.usage_indicator === "P" ? <Pill className="bg-red-50 text-red-700">Production</Pill>
                                             : <Pill className="bg-[#F3F4F6] text-[#374151]">Test</Pill>}
                  <DummyPill show={b.dummy_clearinghouse} />
                </td>
                <td className="px-3 py-2 text-right">
                  {b.kind === "837_file" && b.file_name && <Button kind="outline" onClick={() => download(b)}>Download</Button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default FilesTab;
